import React from "react";
import { IIcon } from "./Icon.types";

const VolumeIcon: React.FC<IIcon> = ({
  width= "36",
  height= "36",
  fill= "#FFFFFF",
  viewBox= "0 0 32 32",
  onClick,
  className,
}: IIcon): React.JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      stroke={fill}
      viewBox={viewBox}
      onClick={onClick}
      className={className}
      data-testid="muteIcon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.7071 7.70711C26.0976 7.31658 26.0976 6.68342 25.7071 6.29289C25.3166 5.90237 24.6834 5.90237 24.2929 6.29289L20 10.5858V6.99999C20 6.58797 19.5296 6.35278 19.2 6.59999L12 12H9C8.44772 12 8 12.4477 8 13V19C8 19.5523 8.44772 20 9 20H10.5858L6.29289 24.2929C5.90237 24.6834 5.90237 25.3166 6.29289 25.7071C6.68342 26.0976 7.31658 26.0976 7.70711 25.7071L25.7071 7.70711ZM19.2 25.4L14.4734 21.855L20 16.3284V25C20 25.412 19.5296 25.6472 19.2 25.4Z"
        fill="white"
      />
    </svg>
  );
};

export default VolumeIcon;
